import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsFloor from 'graphql/fields/FieldsFloor'

const fields = {
	'guid': 'String',
	'building_guid': 'String!',
	'name': 'String!',
	'capacity': 'Int',
	'position': 'Int',
	'available_for': 'String',
	'aed': 'String',
	'active': 'String!',
};

export default gql(`
	mutation floor( ${ HelperGraphql.createFields( fields ) } ) {
	    floor( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsFloor}
	       
	       building {
	          guid
	       }
	    }
	}
`);

